// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2kaoa","info":"Note_info__3doVo","note":"Note_note__2nmSJ","actions":"Note_actions__1hQ7x"};